import { ButtonGroup, ButtonText, Dialog, DialogCardBody, DialogCardFooter, DialogCardHead, DialogCardHeadIcon, DialogCardHeadTitle, Grid, Icon, Typography } from "@visa/vds";
import MCSSpace from "components/MCSSpace";
import React from "react";

const CertificationPackageWarningDialog = (props) => {
    return (
        <>
            <Dialog
                aria-describedby="Certification Package exceed count warning"
                onExit={() => { }}
                open={props.openPackageWarningDialog}
                type="warning"
                titleId="dialog-certification-package-error"
            >
                <DialogCardHead>
                    <DialogCardHeadIcon>
                        <Icon name="error" resolution="low" />
                    </DialogCardHeadIcon>
                    <DialogCardHeadTitle id="dialog-title-manage-file">Warning</DialogCardHeadTitle>
                </DialogCardHead>

                <DialogCardBody id="dialog-description-manage-file-field">
                    <Grid>
                        <Typography tag="h4">There is already a maximum of 6 active packages. Please cancel a package to create a new one.</Typography>
                    </Grid>
                </DialogCardBody>
                <DialogCardFooter>
                    <ButtonGroup direction="right">
                        <ButtonText
                            colorScheme="primary"
                            onClick={(e) => {
                                e.stopPropagation();
                                props.setOpenPackageWarningDialog(false);
                            }}
                        >
                            OK
                        </ButtonText>
                    </ButtonGroup>
                </DialogCardFooter>
            </Dialog>
        </>
    )
}

export default CertificationPackageWarningDialog;